import { FunctionComponent } from "react";
import { Skeleton } from "../../Skeletons";
import { cn } from "../../../utils/cn";

export interface MainStatProps {
  className?: string;
  header: string;
  footer: string;
  body: string;
  loading?: boolean;
}

/**
 *
 */
export const HeadingStatCard: FunctionComponent<MainStatProps> = ({
  className,
  header,
  body,
  footer,
  loading,
}) => {
  const css = cn(
    "relative aspect-video main-stat flex flex-col bg-transparent  items-center justify-center overflow-hidden rounded-lg text-white gap-2",
    className,
  );
  return (
    <div className={css}>
      {loading ? (
        <Skeleton className="h-full w-full" skeletonClassName="h-full" />
      ) : (
        <>
          <Svg />
          <div className={cn("flex flex-col items-center py-16")}>
            <div className="opacity-90">{header}</div>
            <div className="text-4xl font-bold">{body}</div>
            {footer && <div>{footer}</div>}
          </div>
        </>
      )}
    </div>
  );
};

const Svg = () => {
  return (
    // <div className="absolute inset-0">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="absolute inset-0 -z-10 h-full w-full"
      version="1.1"
      width="1440"
      height="560"
      preserveAspectRatio="none"
      viewBox="0 0 1440 560"
    >
      <g mask='url("#SvgjsMask1002")' fill="none">
        <rect
          width="1440"
          height="560"
          x="0"
          y="0"
          fill="rgba(237, 28, 36, 1)"
        />
        <path
          d="M0,592.347C107.351,566.141,156.557,445.943,240.129,373.648C309.09,313.992,411.854,288.312,448.154,204.665C484.323,121.322,436.701,28.842,429.053,-61.688C420.818,-159.161,449.625,-262.731,401.472,-347.878C349.602,-439.596,261.251,-516.404,158.556,-539.992C57.48,-563.208,-47.34,-521.243,-138.567,-471.917C-218.248,-428.834,-270.25,-353.492,-322.812,-279.718C-370.793,-212.373,-411.743,-142.414,-430.677,-61.922C-450.994,24.45,-450.769,111.447,-435.382,198.832C-415.838,309.823,-413.102,437.131,-329.493,512.7C-243.932,590.033,-112.04,619.698,0,592.347"
          fill="#c41017"
        />
        <path
          d="M1440 1063.684C1556.024 1084.716 1674.807 1138.807 1784.993 1096.819 1901.559 1052.399 2019.237 957.3620000000001 2041.233 834.5740000000001 2063.4719999999998 710.434 1935.945 613.408 1892.8220000000001 494.894 1860.868 407.074 1862.07 313.749 1821.153 229.72899999999998 1768.718 122.05599999999998 1738.725-32.82000000000005 1622.254-60.70100000000002 1504.126-88.97799999999995 1420.787 64.45499999999998 1306.876 106.62200000000001 1204.445 144.539 1075.234 100.88799999999998 992.643 172.363 908.297 245.356 886.414 367.882 876.59 478.994 867.113 586.173 884.528 695.899 938.1030000000001 789.2090000000001 989.107 878.0419999999999 1077.128 935.646 1167.001 984.7950000000001 1251.826 1031.184 1344.869 1046.44 1440 1063.684"
          fill="#f14d53"
        />
      </g>
      <defs>
        <mask id="SvgjsMask1002">
          <rect width="1440" height="560" fill="white" />
        </mask>
      </defs>
    </svg>
  );
  // </div>;
};

export default HeadingStatCard;
